<template>
  <div
    class="toast"
    :class="{
      visible: Visible,
    }"
  >
    <img src="@/assets/Images/Global/OK.svg" alt="" class="toast__picto" />
    <p class="toast__message">
      {{
        aplicacion.languageSel == "es"
          ? "Copiado al portapapeles"
          : aplicacion.languageSel == "en"
          ? "Copied to clipboard"
          : aplicacion.languageSel == "fr"
          ? "Copié dans le presse-papiers"
          : aplicacion.languageSel == "de"
          ? "In die Zwischenablage kopiert"
          : aplicacion.languageSel == "it"
          ? "Copiato negli appunti"
          : "Copiado para a área de transferência"
      }}
    </p>
  </div>
</template>

<script>
export default {
  name: "Toast",
  props: {
    aplicacion: Object,
  },
  data() {
    return {
      Visible: false,
    };
  },
  mounted() {
    this.$root.$on("Visible", () => {
      this.Visible = true;
      setTimeout(() => {
        this.Visible = false;
      }, 2500);
    });
  },
};
</script>

<style lang="scss" scoped>
.toast {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: -30px;
  right: calc(50dvw - 235px);
  transform: translate(-50%, -50%);
  pointer-events: none;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  background-color: red;
  z-index: 99999999999999;
  width: 235px;
  height: 30px;
  padding: 10px;
  border-radius: 2px;
  background-color: #4caf50;
  -webkit-transition: top 0.35s ease-in-out;
  -moz-transition: top 0.35s ease-in-out;
  -ms-transition: top 0.35s ease-in-out;
  -o-transition: top 0.35s ease-in-out;
  transition: top 0.35s ease-in-out;
  &__picto {
    margin-right: 10px;
  }
  &__message {
    font-size: 14px;
    font-weight: 500;
  }
  &.visible {
    top: calc($Header-height + 25px);
    -webkit-transition: top 0.35s ease-in-out;
    -moz-transition: top 0.35s ease-in-out;
    -ms-transition: top 0.35s ease-in-out;
    -o-transition: top 0.35s ease-in-out;
    transition: top 0.35s ease-in-out;
  }
}
</style>
